import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=8030aade&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=8030aade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8030aade",
  null
  
)

export default component.exports